<template>
    <div>
        <v-app-bar
                absolute
                flat
                color="white"
                height="75px"
                elevate-on-scroll
        >
            <v-app-bar-nav-icon class="d-lg-none" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
            <v-img
                class="d-lg-none logo-pos mobile-logo"
                src="@/assets/new-logo.svg"
                max-height="70"
                max-width="70"
                contain
            ></v-img>
            <a
            class="d-lg-none" 
            :href="getEspaFile()" 
            download
            >
                <v-img
                    :src="getMobileEspaImage()"
                    max-height="80"
                    max-width="80"
                    contain
                ></v-img>
            </a>
            <v-tabs
                class="d-none d-lg-block" 
                color="red accent-2"
            >
                <v-img
                    class="mt-2 d-none d-lg-block"
                    src="@/assets/new-logo-horizontal.svg"
                    max-width="400"
                    contain
                ></v-img>
                <v-tabs-slider color="#FF5252"></v-tabs-slider> 
                <v-tab style="margin-left: 2vw"  to="/Homepage">{{language=='Ελληνικά'? menu[0].title : menu[0].entitle}}</v-tab>
                <v-tab to="/Available/Projects">{{language=='Ελληνικά'? menu[1].title : menu[1].entitle}}</v-tab>
                <v-tab to="/Projects">{{language=='Ελληνικά'? menu[2].title : menu[2].entitle}}</v-tab>
                <v-tab to="/About">{{language=='Ελληνικά'? menu[3].title : menu[3].entitle}}</v-tab>
                <v-tab to="/ContactUs">{{language=='Ελληνικά'? menu[4].title : menu[4].entitle}}</v-tab>
                <v-tab to="/News">{{language=='Ελληνικά'? menu[5].title : menu[5].entitle}}</v-tab>
            </v-tabs>
            <a :href="getEspaFile()" download>
                <v-img
                    class="d-none d-lg-block" 
                    :src="getEspaImage()"
                    max-height="200"
                    max-width="400"
                    contain
                ></v-img>
            </a>
            <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn  
                        icon
                        v-bind="attrs"
                        v-on="on"
                        class="ml-1"
                    >
                        <v-img
                            width="30px"
                            height="auto"
                            :src="flag"
                        />
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item
                        v-for="(item, index) in languages"
                        :key="index"
                        @click="selectLanguage(item)"
                    >
                        <v-img
                            width="30px"
                            height="auto"
                            :src="getFlag(item)"
                        />
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-app-bar>
        <v-navigation-drawer
            v-model="drawer"
            app
            light
            absolute
            left
            temporary
        >
            <v-list
                nav
                dense
                class="text-center"
            >
                <v-list-item-group
                    v-for="(item, index) in menu"
                    :key="index"
                    v-model="group"
                >
                    <v-list-item class="my-5">
                        <span @click = "menuActionClick(item.route)" style="font-size: 20px">
                            {{language=='Ελληνικά'? item.title : item.entitle}}
                        </span>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>

<script>
    export default {
        props: {
            language: String
        },
        data: () => ({
            drawer: false,
            group: null,
            languages: ['Ελληνικά', 'English'],
            flag: require('@/assets/greece.png'),
            menu: [
                {
                    route: 'HomePage', 
                    title: 'Αρχικη',
                    entitle: 'Home'
                }, 
                {
                    route: 'Available/Projects',
                    title: 'Προς Πωληση',
                    entitle: 'Available Projects'
                },
                {
                    route: 'Projects',
                    title: 'Εργα',
                    entitle: 'Projects'
                },
                { 
                    route: 'About',
                    title: 'Σχετικα Με Εμας',
                    entitle: 'About Us'
                },
                { 
                    route: 'ContactUs',
                    title: 'Επικοινωνια',
                    entitle: 'Contact Us'
                },
                { 
                    route: 'News',
                    title: 'Νεα',
                    entitle: 'News'
                }
            ]
        }),

        watch: {
            group () {
                this.drawer = false
            },
            language: {
                handler (value) {
                    this.flag = this.getFlag(value)
                }
            }
        },
        methods: {
            getFlag(language) {
                if (language == 'Ελληνικά') { 
                    return require('@/assets/greece.png')
                } else {
                    return require('@/assets/uk.png')
                }
            },
            menuActionClick(route) {
                var newPath = '/'+route;
                if(this.$route.path != newPath){
                    this.$router.push({path: newPath})
                }
            },
            goToHome() {
                this.$router.push({name: 'Homepage'});
            },
            selectLanguage(item) {
                this.$store.dispatch("setLanguage", item)
            },
            getMobileEspaImage() {
                if (this.language == 'Ελληνικά') {
                    return require('@/assets/espa-alt.jpg');
                } else {
                    return require('@/assets/espa-en.jpg');
                }
            },
            getEspaImage() {
                if (this.language == 'Ελληνικά') {
                    return require('@/assets/espa-alt-2.jpg');
                } else {
                    return require('@/assets/espa-en-alt.jpg');
                }
            },
            getEspaFile() {
                if (this.language == 'Ελληνικά') {
                    return require('@/assets/site-greek.pdf');
                } else {
                    return require('@/assets/site-english.pdf');
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.logo-pos{
    position: flex;
  }

  .v-btn--icon.v-size--default .v-icon, .v-btn--fab.v-size--default .v-icon{
    font-size: 35px;
    color: #7b7b7d;
  }

  .v-tab {
    // font-weight: bolder;
    font-size: 15px;
    color: #7b7b7d!important;
  }
  .v-tab:before {
    opacity: 0;
    pointer-events: none;
    position: absolute;
    background-color: transparent;
  }
  .v-tab--active {
    color: #7b7b7d!important;
  }
  .mobile-logo {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
  }
</style>

